import ButtonOutline from "kreate-common/modules/kreate-ui/components/ButtonOutline";
import ButtonPrimary from "kreate-common/modules/kreate-ui/components/ButtonPrimary";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import ModalV2 from "kreate-common/modules/kreate-ui/components/ModalV2";
import React from "react";

import FieldListingPrice from "../ModalMintAndList/fields/FieldListingPrice";
import { useFieldListingPrice } from "../ModalMintAndList/fields/FieldListingPrice/hooks";
import FieldNumEditions from "../ModalMintAndList/fields/FieldNumEditions";
import { useFieldNumEditions } from "../ModalMintAndList/fields/FieldNumEditions/hooks";

import { useBusyCount } from "@/modules/common-hooks/useBusyCount";

type SubmitEvent = {
  numEditions: number;
  listingPrice: number;
};

export type ModalUpdateListingDetailsPrompt$SubmitEvent = SubmitEvent;

type Props = {
  open: boolean;
  initialNumEditions: number | undefined;
  initialListingPrice: number | undefined;
  onCancel?: () => void;
  onSubmit?: (event: SubmitEvent) => void;
};

export default function ModalUpdateListingDetailsPrompt({
  open,
  initialNumEditions,
  initialListingPrice,
  onCancel,
  onSubmit,
}: Props) {
  const fieldNumEditions = useFieldNumEditions({
    initialValue: initialNumEditions,
    min: 0,
    max: 1e6,
  });

  const fieldListingPrice = useFieldListingPrice({
    initialValue: initialListingPrice,
    min: 1e6,
    max: 1e12,
  });

  const { busy, withDefaultErrorHandler } = useBusyCount();

  const handleSubmit = withDefaultErrorHandler(() => {
    const numEditions = fieldNumEditions.validateBeforeSubmitting();
    const listingPrice = fieldListingPrice.validateBeforeSubmitting();
    onSubmit?.({ numEditions, listingPrice });
  });

  return (
    <ModalV2 open={open} onClose={onCancel} closeOnDimmerClick closeOnEscape>
      <ModalV2.HeaderV2
        title="Update listing details (1/2)"
        description="Update the number of Editions and price of your listed Artwork."
      />
      <ModalV2.Content>
        <Flex.Col gap="24px">
          <FieldNumEditions api={fieldNumEditions} disabled={busy} />
          <FieldListingPrice api={fieldListingPrice} disabled={busy} />
        </Flex.Col>
      </ModalV2.Content>
      <ModalV2.Actions>
        <ButtonOutline content="Cancel" onClick={onCancel} />
        <ButtonPrimary content="Next" onClick={handleSubmit} />
      </ModalV2.Actions>
    </ModalV2>
  );
}
